var h = Object.defineProperty, d = Object.defineProperties;
var x = Object.getOwnPropertyDescriptors;
var p = Object.getOwnPropertySymbols;
var i = Object.prototype.hasOwnProperty, a = Object.prototype.propertyIsEnumerable;
var u = (t, n, o) => n in t ? h(t, n, { enumerable: !0, configurable: !0, writable: !0, value: o }) : t[n] = o, s = (t, n) => {
  for (var o in n || (n = {}))
    i.call(n, o) && u(t, o, n[o]);
  if (p)
    for (var o of p(n))
      a.call(n, o) && u(t, o, n[o]);
  return t;
}, l = (t, n) => d(t, x(n));
var m = (t, n) => {
  var o = {};
  for (var e in t)
    i.call(t, e) && n.indexOf(e) < 0 && (o[e] = t[e]);
  if (t != null && p)
    for (var e of p(t))
      n.indexOf(e) < 0 && a.call(t, e) && (o[e] = t[e]);
  return o;
};
import { j as _ } from "../../../jsx-runtime-c20f6c15.mjs";
import j from "clsx";
import y from "react-phone-number-input";
import "react";
const N = "_phoneInput_onx20_1", P = {
  phoneInput: N
};
function v(b) {
  var r = b, {
    className: t,
    placeholder: n,
    defaultCountry: o,
    onChange: e
  } = r, f = m(r, [
    "className",
    "placeholder",
    "defaultCountry",
    "onChange"
  ]);
  function I(c) {
    e == null || e(c || "");
  }
  return /* @__PURE__ */ _(
    y,
    l(s({}, f), {
      addInternationalOption: !1,
      className: j(P.phoneInput, t),
      defaultCountry: o,
      international: !0,
      placeholder: n,
      withCountryCallingCode: !0,
      onChange: I
    })
  );
}
export {
  v as default
};
